
export class BaseModel {
}
